/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {

    import IPhoneModelValue = Meevo.Components.Controls.HideInput.IPhoneModelValue;
    import CultureSettings = Meevo.Components.Common.CultureSettings;

    class LoginController {
        public static $inject = [
            '$scope',
            'meevo.components.common.DataService',
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic',
            'meevo.AppSettings',
            '$state',
            'meevo.components.tracking.TrackingService',
            'meevo.components.busy.BusyService'
        ];

        email: string;
        phone: IPhoneModelValue;

        phoneInputName: string;
        emailInputName: string;

        errorMessage: string;

        constructor(protected $scope: ng.IScope,
                    protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected selfCheckInKioskLogic: SelfCheckInKioskLogic,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $state: ng.ui.IStateService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService) {
            this.phoneInputName = `phone-${new Date().getTime()}`;
            this.emailInputName = `email-${new Date().getTime()}`;

            this.email = '';
            this.phone = {
                countryCode: CultureSettings.getByProperty('locale', appSettings.APP_COUNTRYID).countryCode,
                phoneNumber: ''
            };

            $scope.$watch(() => {
                return {
                    phone: this.phone.phoneNumber,
                    countryCode: this.phone.countryCode,
                    email: this.email
                };
            }, () => {
                if (this.phone.phoneNumber) {
                    this.errorMessage = '';
                }
            }, true);
        }

        search() {
            this.busyService.start();

            setTimeout(() => {
                const item = new Model.TrackingItem(Model.NounEnum.SelfCheckInKiosk, Model.VerbEnum.SearchButtonClicked, null, null);
                this.trackingService.saveTrackingInfo(item);
                this.selfCheckInKioskLogic.reset();

                this.selfCheckInKioskLogic.searchForClient({
                    phone: this.phone.phoneNumber,
                    countryCode: this.phone.countryCode,
                    email: this.email
                })
                    .then(() => this.selfCheckInKioskLogic.loadClients())
                    .then(() => this.selfCheckInKioskLogic.loadAppointments())
                    .then(() => {
                        this.$state.go(this.appSettings.ROUTE_NAMES.selfCheckInKiosk + '.' + 'client-info');
                    })
                    .catch((error: Error) => {
                        this.errorMessage = error.message;

                        this.selfCheckInKioskLogic.reset();
                    }).finally(() => {
                    this.email = '';
                    this.phone = {
                        countryCode: '1',
                        phoneNumber: ''
                    };

                    this.busyService.stop();
                });
            });
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.LoginController', LoginController);
}
